<app-spinner></app-spinner>
<div class="content">

    <div *ngIf="shown.grid" class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding: 10px;">

        <button class="formbutton" (click)="AttributeForm()" mat-flat-button>Add </button>

        <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">

            <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->


            <ng-container matColumnDef="Id">
                <th mat-header-cell *matHeaderCellDef>Id</th>
                <td mat-cell *matCellDef="let element">{{element.attributeId}}</td>
            </ng-container>

            <ng-container matColumnDef="entity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Entity</th>
                <td mat-cell *matCellDef="let element">{{element.entityType}}</td>
            </ng-container>


            <!-- Position Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>


            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef>Edit</th>
                <td mat-cell *matCellDef="let element" (click)=" editAttribute(element.attributeId)">
                    <img src="assets/img/icons/forma-1-copy-2.png ">
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef>Delete</th>
                <td mat-cell *matCellDef="let element;let i = index" (click)="deleteAttribute(element.attributeId,i)">
                    <img src="assets/img/icons/forma-1.png ">
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>

    <!-- Form Begin -->
    <div *ngIf="shown.Form">
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="padding: 30px;">
            <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <mat-card-header>
                    <mat-card-title>

                        <div class="backcontainer">
                            <div class="Back" (click)="backattributeList()">
                                <img src="assets/img/icons/shape-1.png"> <span>Back</span>
                            </div>
                        </div>
                        <div class="headLabel">Add Attribute</div>

                    </mat-card-title>
                </mat-card-header>


                <form [formGroup]="Attribute" class="example-form">
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">Entity:</div>
                        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input matInput placeholder="" formControlName="entityType" readonly>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">UniqueName:</div>
                        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input matInput placeholder="" formControlName="name" value="">
                            </mat-form-field>
                            <mat-error *ngIf="validator.UniqueAttribute">{{validator.errorMessage}}</mat-error>
                        </div>
                    </div>


                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">UI Name:</div>
                        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input matInput placeholder="" formControlName="uiName" value="">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <mat-checkbox class="flabel" formControlName="isShowInfo">Show in info Hightlights/Highlighted</mat-checkbox><br/>
                        <mat-checkbox class="flabel" formControlName="isShowAlgo">Show Consider algorithm</mat-checkbox><br/>
                        <mat-checkbox class="flabel" formControlName="isUnique">Unique</mat-checkbox><br/>
                        <mat-checkbox class="flabel" formControlName="isCustom">Show in custom UI</mat-checkbox>
                    </div>

                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">Corelation value:</div>
                        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:95%">
                                <input matInput placeholder="" type="number" formControlName="correlationValue" value="">
                            </mat-form-field>
                            <span> %</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2"></div>
                        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
                            <button [disabled]="!Attribute.valid" style="width:100%" mat-flat-button class="formbutton" (click)="createAttribute()">Add</button>
                        </div>
                    </div>
                </form>
            </mat-card>
        </div>
    </div>
</div>